// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"9efa0d88","233":"a500ccaa","287":"255d953c","408":"d2cd563d","461":"696c0182","746":"e95c518a"}[chunkId] + ".chunk.js";
};